<form name="editForm" #f="ngForm" role="form" novalidate (ngSubmit)="isvalid(f) && saveConfiguration()"
        [formGroup]="configurationForm">
<div class="searchForm flex-row" >
    <div class="form-row formTile">
        <div class="col-12"><i class="fas fa-cogs"></i> Configuration : </div>
    </div>
      <div class="form-row">
        <div class="col-2">
          <label  for="Description" >Label</label>
        </div>
        <div class="col-6">
          <input type="text" formControlName="label" class="form-control mb-2"
          [ngClass]="{ 'forminput-invalid':f.submitted &&
          configurationForm.controls['label']?.errors}"
             id="Description" placeholder="Description ">

             <div *ngIf="f.submitted && configurationForm.controls['label']?.errors?.required" class="help-block text" >Champs Obligatoire</div>
        </div>

      </div>
      <div class="form-row">
          <div class="col-2">
              <label  for="Description" >Type</label>
          </div>
          <div class="col-6">
              <ng-select class="mb-2"
              dropdownPosition='bottom' placeholder="Type De Place"
                [items]="configurationTypes" [multiple]="false"
                [bindLabel]="'label'"
                [closeOnSelect]="true" bindValue="name" formControlName="type"
                name="selectType">
              </ng-select>
          </div>
      </div>
      <div class="row" style="margin-bottom: 8px;">
          <div class="col-2">
              <label  for="Description" >Status</label>
          </div>
          <div class="col-2">
              <input type="checkbox" name="active"
              formControlName="active"><span >&nbsp; Active </span>
          </div>
      </div>
      <ng-container *ngIf="configurationForm['controls']?.type.value == 'Paying'">
        <fieldset class="border p-2">
          <legend class="w-auto">Tarification :</legend>
        <div class=" p-2">
          <div class="d-flex p-2 flex-row-reverse" >
            <!-- <div>
              Tarification :
            </div> -->
            <div class="col-2">
              <ng-container *ngIf="!configurationPayment">
              <button type="button" (click)="addConfigurationPayment()"
              class="btn btn-indigo btn-sm btn-block"
              style= "margin-left: 0px;margin-right: 0px;width: 100%;min-width: none;"
              >Ajouter</button>
            </ng-container>
            <ng-container *ngIf="configurationPayment">
              <button type="button" (click)="removeConfigurationPayment()"
              class="btn btn-danger btn-sm btn-block"
              style= "margin-left: 0px;margin-right: 0px;width: 100%;min-width: none;"
              >Supprimer</button>
            </ng-container>
            </div>
          </div>
      <ng-container *ngIf="configurationForm['controls'].configPaying" formGroupName="configPaying">
        <div class="row" style="margin-bottom: 8px;">
          <div class="col-2">
              <label  for="active" >Status</label>
          </div>
          <div class="col-2">
              <input type="checkbox" name="active"
              formControlName="active"><span >&nbsp; Active </span>
          </div>
        </div>
        <div class="row" style="margin-bottom: 8px;">
          <div class="col-2">
              <label  for="freeTimeMinute" >Temps gratuit </label>
          </div>
          <div class="col-2">
            <ngb-timepicker class="mb-2" formControlName="freeTimeMinute"></ngb-timepicker>
          </div>
        </div>
        <div class="row" style="margin-bottom: 8px;">
          <div class="col-2">
              <label  for="price" >Tarif </label>
          </div>
          <div class="col-4">
              <input type="number" #price name="price" [ngClass]="{ 'forminput-invalid':f.submitted &&
              configurationPayment.controls['price']?.errors}"
              formControlName="price" class="form-control">
              <div *ngIf="f.submitted && configurationPayment.controls['price']?.errors?.required" class="help-block text" >Champs Obligatoire</div>
          </div>
        </div>
        <div class="row" style="margin-bottom: 8px;">
          <div class="col-2">
          </div>
          <div class="col-6">
            <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" formArrayName="untilPublicHoliday" id="customSwitch1">
              <label class="custom-control-label" for="customSwitch1">Jours fèriés inclus</label>
            </div>
        </div>
        </div>
        <fieldset class="border p-2">
          <legend class="w-auto">Planification :</legend>
            <div class="d-flex p-2 flex-row-reverse" >
              <!-- <div>
                Planification :
              </div> -->
              <div>
                <button type="button" (click)="addTimeConfig()"
                class="btn btn-indigo btn-sm btn-block"
                style= "margin-left: 0px;margin-right: 0px;width: 100%;min-width: none;"
                >Ajouter</button>
              </div>
            </div>
      <ng-container formArrayName="timeConfig">
        <ng-container *ngFor="let timeConf of timeConfigs.controls; let i=index">
          <ng-container [formGroupName]="i">
            <fieldset class="border p-2">
                <legend class="w-auto">Occurence :</legend>
            <div class="d-flex ">
            <div class=" col-10">

            <div class="row" style="margin-bottom: 8px;" >
            <div class="col-2">
                <label  for="dayInWeek" >Jours </label>
            </div>
            <div class="col-6">

                <ng-select class="mb-2"
                dropdownPosition='bottom' placeholder="Jours"
                [items]="jours" [multiple]="true"
                [bindLabel]="'name'"
                [closeOnSelect]="false" bindValue="id" formControlName="dayInWeek"
                [ngClass]="{ 'forminput-invalid':f.submitted && timeConfigs.controls[i].get('dayInWeek')?.errors}"
                name="selectType">
                <ng-template ng-header-tmp>
                  <div>
                    <button class="btn btn-link" type="button"
                            (click)="onSelectSemaine(i)">Toute la semaine</button>
                    <button class="btn btn-link" type="button"
                            (click)="onSelectWeekend(i)">le weekend</button>
                  </div>

                </ng-template>
              </ng-select>
              <div *ngIf="f.submitted && timeConfigs.controls[i].get('dayInWeek')?.errors?.required" class="help-block text" >Champs Obligatoire</div>
            </div>
          </div>
          <ng-container formArrayName="timeSlots">
            <ng-container
            *ngFor="let timeSlot of timeConfigsTimeSlots(i).controls;let timeSlotIndex=index" >
              <ng-container [formGroupName]="timeSlotIndex">
                <ng-container formGroupName="TimeSlot">
                    <div class="row" style="margin-bottom: 8px;">
                      <div class="col-2">
                          <label  for="TimeStart" > Heure debut </label>
                      </div>
                      <div class="col-6">
                        <ngb-timepicker class="mb-2" formControlName="TimeStart"></ngb-timepicker>
                      </div>
                    </div>
                    <div class="row" style="margin-bottom: 8px;">
                      <div class="col-2">
                          <label  for="dayInWeek" > Heure Fin </label>
                      </div>
                      <div class="col-6">
                        <ngb-timepicker class="mb-2" formControlName="TimeEnd"></ngb-timepicker>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
      </div>
      <div class="item-relative">
        <button type="button" (click)="removeTimeConfig(i)"
        class="btn btn-danger btn-sm btn-block"
        style= "margin-left: 0px;margin-right: 0px;width: 100%;min-width: none;"
        >Supprimer</button>
      </div>
    </div>
    </fieldset>
        </ng-container>

        </ng-container>
      </ng-container>
    </fieldset>
      </ng-container>
    </div>
  </fieldset>
  </ng-container>
    <div class="form-row p-2 justify-content-center">
      <div class=" col-2">
        <button type="button"
        class="btn  btn-secondary btn-sm btn-block"
        [routerLink]="['/configurations']"
        style= "margin-left: 0px;margin-right: 0px;width: 100%;min-width: none;"
        >Annuler</button>
      </div>
      <div class=" col-2">
          <button  type="submit"
          class="btn btn-indigo btn-sm btn-block"
          style= "margin-left: 0px;margin-right: 0px;width: 100%;min-width: none;"
          >Valider</button>
      </div>
    </div>
  </div>
</form>
